import { SafeAreaView } from "moti";
import React, { useState } from "react";

import {
    TextInput,
    Dimensions,
    View,
    Modal,
    Text,
    TouchableOpacityProps,
    TouchableOpacity
} from "react-native";
import SVGView from "../utils/SvgView";
import AppTheme from "../utils/Theme";
import Style from "../utils/Style";

const RoundIconButton = (props: TouchableOpacityProps & {iconName:any, backgroundColor:string, iconSize?: number}) => {

    const appTheme: AppTheme = new AppTheme();

    const { iconName, backgroundColor=appTheme.darkBlue, iconSize = appTheme.pixelPerfect(42)} = props;

    return (
        <TouchableOpacity
            style={[ Style.shadowed, {
                justifyContent:"center",
                alignItems:"center",
                borderRadius:appTheme.pixelPerfect(35),
                width: appTheme.pixelPerfect(70),
                height: appTheme.pixelPerfect(70),
                backgroundColor: backgroundColor
            }]}
            {...props}>
                <SVGView Component={iconName} size={iconSize} color={appTheme.white} />
        </TouchableOpacity>
    )
}

export default RoundIconButton;
